exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-643d9333]{margin-top:35px}.handle[data-v-643d9333]{float:left}.close[data-v-643d9333],.handle[data-v-643d9333]{padding-top:8px;padding-bottom:8px}.close[data-v-643d9333]{float:right}input[data-v-643d9333]{display:inline-block;width:50%}.text[data-v-643d9333]{margin:20px}", ""]);

// exports
